import { EExerciseType, TExerciseItem } from "types/app/exercises";

export const describeVideoExercise: TExerciseItem = {
  title: "Відео",
  backgroundText: "Відео",
  tags: ["Відео", "описати", "video", "describe"],
  type: EExerciseType.VIDEO,
  cover: "describe-video.png",
};
